var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"120px"},attrs:{"src":require("../../../assets/images/logo/monmi-rm.png"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }